import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Section, Eyebrow } from "../../components/public/Section";
import { PageHero } from "./About";
import { Plus, Minus } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export default function FAQPage() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(0);
  useEffect(() => { api.get("/public/faqs").then(r => setItems(r.data)); }, []);
  return (
    <>
      <PageHero title="Frequently Asked" subtitle="Everything you wanted to know before your inquiry." image="https://images.unsplash.com/photo-1551024709-8f23befc6f87?auto=format&fit=crop&w=2000&q=80" />
      <Section>
        <Eyebrow>Common Questions</Eyebrow>
        <div className="max-w-3xl divide-y divide-navy-900/10 mt-6">
          {items.map((f, i) => (
            <div key={f.id} data-testid={`faq-${i}`}>
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full text-left py-6 flex items-center justify-between gap-6 hover:text-gold transition"
              >
                <span className="serif text-xl">{f.q}</span>
                {open === i ? <Minus size={18} className="text-gold shrink-0" /> : <Plus size={18} className="text-gold shrink-0" />}
              </button>
              <AnimatePresence>
                {open === i && (
                  <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="overflow-hidden">
                    <p className="text-navy-900/50 pb-6 leading-relaxed">{f.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </Section>
    </>
  );
}
